interface Props {
  width?: number;
  height?: number;
}

// AI sparkle icon with gradient
export function AiSparkle({ width = 24, height = 24 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <path
        fill="url(#a)"
        d="m10.015 4.49-2.26 3.887-.362.362L3.505 11l3.38 1.965-1.63 1.367-4.242-2.468v-1.728l5.146-2.993L9.15 1.997h1.729l2.992 5.146 5.146 2.993v1.729l-5.146 2.992-2.992 5.146H9.15l-2.472-4.254 1.554-1.304 1.783 3.066 2.261-3.888.362-.362L16.526 11l-3.888-2.26-.362-.363-2.26-3.888Z"
      />
      <path
        fill="url(#b)"
        d="m20.797 18.194-1.28-2.203-1.282 2.203-2.202 1.28 2.202 1.282 1.281 2.203 1.281-2.203L23 19.475l-2.203-1.281Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="2.782"
          x2="20.206"
          y1="1.997"
          y2="23.779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBF6E" />
          <stop offset=".26" stopColor="#FEA048" />
          <stop offset=".39" stopColor="#FF7F24" />
          <stop offset=".5" stopColor="#FF4F00" />
          <stop offset=".61" stopColor="#FF5789" />
          <stop offset=".74" stopColor="#F589DC" />
          <stop offset="1" stopColor="#C1B7FF" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="2.782"
          x2="20.206"
          y1="1.997"
          y2="23.779"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBF6E" />
          <stop offset=".26" stopColor="#FEA048" />
          <stop offset=".39" stopColor="#FF7F24" />
          <stop offset=".5" stopColor="#FF4F00" />
          <stop offset=".61" stopColor="#FF5789" />
          <stop offset=".74" stopColor="#F589DC" />
          <stop offset="1" stopColor="#C1B7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
